/**
 * 中行需要引入cordova前置条件
 * @date 2021-09-17
 * @returns {any}
 */
export function DeviceReady() {
  return new Promise<void>((resolve) => {
    document.addEventListener('deviceready', () => {
      resolve();
    });
  });
}

/** 端口映射 */
export const SYSTEM_CODE_MAP = {
  /** 云闪付 */
  UNION_PAY: '2005',
  /** 高德 */
  GAODE: 'O3',
  /** 中行 */
  BOC: '2200',
  /** 招行 */
  CMB: 'f3',
  /** 天津地铁 */
  TJC: 'V3',
  /** 微信 */
  WECHAT: '64',
  /** 天府云 */
  CD_APP: 'b3',
  /** 哈啰app */
  HELLO_APP: '62',
  /** ai温州 */
  AIWZ: 'w3',
  /** 建行生活 */
  CCB: 'Aa3',
  /** 掌上生活 */
  CMB_LIFE: 'HB001',
  /** 随申行 */
  SSX: 'HB003',
  /** 大理 */
  DALI: '2003',
  /** 今日闵行 */
  JRMH: '2101',
  /** 绿喵 */
  LVMIAO: '2100',
};